import { Resource } from 'i18next';

const resources: Resource = {
  tr: {
    translation: {
      components: {},
      modules: {
        error: {
          goToHome: 'Anasayfaya Gidiniz',
          error404: {
            notFound: 'Sayfa Bulunamadı',
            yourPageNotFound: 'Aradığını sayfa bulunamadı.',
            differentPage: 'Bir başka sayfaya gidebilirsiniz.',
          },
          error500: {
            systemError: 'Sistem Hatası',
            wentWrong: 'Birşeyler ters gitti.',
            tryAgain: 'Lütfen daha sonra tekrar deneyin.',
          },
        },
      },
      pages: {
        dealerAccountSetting: {
          addressInformation: {
            invoiceAddresses: 'FATURA ADRESLERİ',
            financeOfficer: 'Finans sorumlusu',
            operationalProcessManager: 'Operasyonel süreç sorumlusu',
            province: 'il',
            district: 'ilçe',
            neighbourhood: 'Mahalle',
            postCode: 'Posta Kodu',
            address: 'Adres',
            update: 'GÜNCELLE',
            shipmentAddresses: 'SEVKİYAT ADRESLERİ',
            returnAddresses: 'İADE ADRESLERİ',
            save: 'Kaydet',
            addressType: 'Adres Türü',
            addressInfo: 'ADRES BİLGİLERİ',
            contactInfo: 'İLETİŞİM BİLGİLERİ',
          },
          bankInformation: {
            bankName: 'Banka Adı',
            accountHolderNameTitle: 'Hesap Sahibinin Adı/Ünvanı',
            sendForApprov: 'Onaya gönder',
            save: 'Kaydet',
          },
          commission: {
            commissionTable: 'KOMİSYON TABLOSU',
            commissionType: 'KOMİSYON TİPİ',
            product: 'Ürün',
            category: 'Kategori',
            brand: 'Marka',
            dealer: 'Satıcı',
            categories: 'KATEGORİ',
            subCategory: 'ALT KATEGORİ',
            commissionIncludingVAT: 'KDV DAHİL KOMİSYON',
            validityDate: 'GEÇERLİLİK TARİHİ',
            prev: 'prev',
            next: 'next',
            search: 'ARA',
            dealerCommission: 'Satıcı Komisyonu',
            commissionDesc: 'Kategori, ürün ya da marka-kategori bazında herhangi bir komisyon oranı girilmedi ise komisyon default bu değerden hesaplanacaktır.',
          },
          companyInformation: {
            nameSurname: 'Ad Soyad',
            cellPhoneNumber: 'Cep No',
            storeName: 'Firma Adı',
            currentTitle: 'Cari Ünvan',
            companyType: 'Şirket Türü',
            province: 'İl',
            district: 'İlçe',
            email: 'E-posta',
            sellerId: 'Satıcı ID',
            taxAdministration: 'Vergi Dairesi',
            taxIdentificationNumber: 'Vergi Kimlik No',
            kepMailAddress: 'Kep Mail Adresi',
            mersisNo: 'Mersis No',
            tradeRegisterNumber: 'Ticaret Sicil No',
            invoiceType: 'Fatura Türü',
            deliveryTimeToCargo: 'Kargoya Teslim Süresi (İşgünü)',
            save: 'Kaydet',
          },
          contactInformation: {
            responsible: 'Sorumlu',
            email: 'E-Mail',
            nameSurname: 'Ad, Soyad',
            mobilePhoneNumber: ' Cep No',
            save: 'Kaydet',
            responsibleLowerCase: 'Sorumlu',
            store: 'Mağaza',
            contactType: 'İletişim Türü',
          },
          dealerAccountSetting: {
            companyInformation: 'FİRMA BİLGİLERİ',
            shopShowcase: 'MAĞAZA VİTRİN',
            contactInformation: 'İLETİŞİM BİLGİLERİ',
            banknformation: 'BANKA BİLGİLERİ',
            addressInfo: 'ADRES BİLGİLERİ',
            operationalInformation: 'OPERASYONEL BİLGİLER',
            specialSettings: 'ÖZEL AYARLAR',
            commission: 'KOMİSYON',
            maturity: 'VADE',
            documents: 'BELGELER',
            apiInformation: 'API BİLGİLERİ',
            users: 'KULLANICILAR',
          },
          documents: {
            contractName: 'Sözleşme Adı',
            explanation: 'Açıklama',
            status: 'Durum',
            dateOfUpload: 'Eklenme Tarihi',
            sellerMembershipAgreement: 'Satıcı Üyelik Sözleşmesi',
            containsTheContract: 'sözleşme kapsamını içerir.',
            rejected: 'Reddedildi',
            approved: 'Onaylandı',
            detail: 'Detay',
            tradeRegistry: 'Ticaret Sicili',
            operatingCertificate: 'Faaliyet Belgesi',
            notAdded: 'Eklenmemiş',
            circularSignatureSignatures: 'İmza Sirküleri / imza beyannamesi',
            taxBoard: 'Vergi Levhası',
            waitingForApproval: 'Onay bekliyor',
          },
          operationInformation: {
            orderDeliveryShippingInformation: 'Sipariş teslimat kargo bilgileri',
            returnShippingInformation: 'İade kargo bilgileri',
            cargoType: 'Kargo Tipi',
            chooseInstallationType: 'Yükleme Tipi Seçin',
            selectShipping: 'Kargo Seçiniz',
            cargoCompany: 'Kargo Firması',
            startingDate: 'Başlangıç Tarihi',
            status: 'Durum',
            platformAgreement: 'Platform Anlaşmalı',
            sellerAgreement: 'Satıcı Anlaşmalı',
            save: 'Kaydet',
            record: 'KAYIT',
          },
          privateSettings: {
            autoConfirm: 'Sipariş geldiğinde otomatik onaylansın',
            noQuestionsProduct: 'Ürün ile ilgili soru sorulmasın',
            noQuestionsOrder: 'Sipariş ile ilgili soru sorulmasın',
            returnApprovalDays: 'İade Otomatik Onay Gün Sayısı',
            minimumBasketAmount: 'Minimum Sepet Tutarı',
            vacationMode: 'Tatil Modu',
            vacationModeDescription: 'Tatil modunu açtığınızda tüm stoklarınız sıfırlanacaktır. Yeniden aktif hale getirdiğinizde yeniden stok gönderimi yapmanız gerekecektir.',
            save: 'Kaydet',
          },
          storeManagement: {
            shopSelection: 'Mağaza Seçimi',
            shopBanner: 'Mağaza Banner',
            products: 'Ürünler',
            categories: 'KATEGORİLER',
            uploadType: 'Yükleme tipi seçiniz',
            storeDescription: 'Mağaza Açıklaması',
            save: 'Kaydet',
          },
          maturity: {
            maturityTable: 'VADE TABLOSU',
            maturityType: 'VADE TİPİ',
            category: 'KATEGORİ',
            subCategory: 'ALT KATEGORİ',
            maturity: 'VADE',
            validityDate: 'GEÇERLİLİK TARİHİ',
            product: 'Ürün',
            categories: 'Kategori',
            brand: 'Marka',
            seller: 'Satıcı',
            search: 'ARA',
            dealerMaturity: 'Satıcı Vadesi',
            maturityDesc: 'Kategori, ürün ya da marka-kategori bazında herhangi bir vade oranı girilmedi ise vade default bu değerden hesaplanacaktır.',
          },
          apiInformation: {
            sellerId: 'Satıcı ID',
            apiKey: 'API KEY',
            expireDate: 'Bitiş Tarihi',
            createdAt: 'Oluşturma Tarihi',
            apiSecret: 'API Secret',
            updateMyApiInfo: 'API Bilgilerimi Güncelle',
            deleteMyApiInfo: 'Sil',
          },
          modals: {
            userName: 'Kullanıcı Adı',
            email: 'E-mail',
            telNo: 'Cep No',
            role: 'Rol',
            saveButton: 'Kaydet',
            nameSurname: 'Ad Soyad',
            status: 'Durum',
            createDate: 'Oluşturulma Tarihi',
            updateDate: 'Güncelleme Tarihi',
            operations: 'İşlemler',
            updateUserInformation: 'Kullanıcı Bilgileri Güncelleme',
            updateOperationalInformation: 'OPERASYON BİLGİLERİ GÜNCELLEME',
            startingDate: 'Başlangıç Tarihi',
          },
        },
        products: {
          questions: {
            pageTitle: 'ÜRÜN SORULARI',
            dateRange: 'Tarih Aralığı',
            isPopulerQuestion: 'Popüler soru mu ?',
            state: 'Durum',
            trademark: 'Marka',
            barcode: 'Barkod',
            myReadyAnswers: 'Hazır Cevaplarım',
            messageDate: 'Mesaj Tarihi',
            productInformation: 'Ürün Bilgisi',
            detail: 'Detay',
            isLive: 'Yayında mı?',
            process: 'Aksiyon',
            filter: 'Filtrele',
            answerDate: 'Cevap Tarihi',
            question: 'Soru',
            answer: 'Cevap',
            status: 'Durum',
            lastCreatedDate: 'Soru Oluşturulma Tarihi',
          },
          evaluation: {
            pageTitle: 'ÜRÜN DEĞERLENDİRMELERİ',
            dateRange: 'Tarih Aralığı',
            state: 'Durum',
            trademark: 'Marka',
            productNameBarCode: 'Ürün ismi / Barkod',
            category: 'Kategori',
            productInformation: 'Ürün Bilgileri',
            createdDate: 'Oluşturulma Tarihi',
            averageProductRating: 'Ortalama Ürün Puanı',
            showCommentsOnly: 'Yalnızca yorumları göster',
            images: 'Görsel',
            rating: 'Puan',
            comment: 'Yorum',
            filter: 'Filtrele',
          },
          productList: {
            catalogProductList: {
              productManagement: 'ÜRÜN YÖNETİMİ',
              catalogProductListing: 'KATALOG ÜRÜN LİSTELEME',
              nameOfTheProduct: 'Ürün Adı',
              stockCode: 'Stok Kodu',
              barcode: 'Barkod',
              category: 'Kategori',
              brand: 'Marka',
              productStatus: 'Ürün Durumu',
              search: 'ARA',
              column: 'Column',
              addProduct: 'Ürün Ekle',
              downloadExcel: 'Excel İndir',
              commission: 'Komisyon',
              recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
              idefixSalesPrice: 'İdefix Satış Fiyatı',
              lowestPrice: 'En Düşük Fiyat',
              buyboxQueue: 'Buybox Sırası',
              stock: 'Stok',
              status: 'Durum',
              transactions: 'İşlemler',
            },
            poolProductList: {
              productManagement: 'ÜRÜN YÖNETİMİ',
              poolProductListing: 'HAVUZ ÜRÜN LİSTELEME',
              nameOfTheProduct: 'Ürün Adı',
              stockCode: 'Stok Kodu',
              barcode: 'Barkod',
              category: 'Kategori',
              brand: 'Marka',
              productStatus: 'Ürün Durumu',
              search: 'ARA',
              column: 'Column',
              addProduct: 'Ürün Ekle',
              downloadExcel: 'Excel İndir',
              commission: 'Komisyon',
              recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
              idefixSalesPrice: 'İdefix Satış Fiyatı',
              lowestPrice: 'En Düşük Fiyat',
              buyboxQueue: 'Buybox Sırası',
              stock: 'Stok',
              status: 'Durum',
              transactions: 'İşlemler',
              IDEProductCode: 'IDE Ürün Kodu',
              categories: 'Kategori',
              creationDate: 'Oluşturulma Tarihi',
              dateOfUpdate: 'Güncelleme Tarihi',
            },
            addFromCatalog: {
              searchTitle: 'KATALOGDAKİ ÜRÜNE STOK, FİYAT EKLE',
              searchDescription:
                'Satışını yapmak istediğiniz ürünü mağazanıza eklemek için Barkod ,GTIN ya da Ürün Adı kullanarak katalogdan aratabilirsiniz. Virgül ile birden çok ürün arayabilirsiniz.',
              searchInputPlaceholder: 'Ürün adı, barkod, GTIN ile arayın',
              searchResult: 'Arama Sonuç',
              foundedProduct: 'ürün bulundu.',
              searchResultText: 'Aradığınız ürün katalogda yoksa yeni ürün ekleyebilirsiniz.',
              addNewProduct: 'Yeni ürün ekle',
              sellTheProduct: 'Ürünü Satışa Aç',
              sellerStockCode: 'Satıcı Stok Kodu',
              amountOfStock: 'Stok Miktarı',
              psf: 'PSF',
              idefixSalesPrice: 'Idefix Satış Fiyatı',
              goProductButtonName: 'Ürüne Git',
              approveButtonName: 'Satış Yapabilmek İçin Onaya Gönder',
              uploadButton: 'Upload',
              lastUserPrice: 'Piyasa Satış Fiyatı',
              estimatedDeliveryTime: 'Kargoya Teslim Süresi',
              image: 'Görsel',
              barcode: 'Barkod',
              category: 'Kategori',
              brand: 'Marka',
              commision: 'Komisyon',
              kdv: 'KDV',
              color: 'Renk',
              memory: 'Hafıza',
              size: 'Beden',
              lowestPrice: 'Ürüne Ait En Düşük Fiyat',
              product: 'Ürün Adı',
              operations: 'İşlemler',
              similarProducts: 'Ürünün Diğer Varyantları',
            },
            createSingleProduct: {
              sendApproveButton: 'Ürünü Onaya Gönder',
              productInformation: 'ÜRÜN BİLGİLERİ',
              productNameLabel: 'Ürün Adı Giriniz',
              productNamePlaceholder: 'ürün adı...',
              selectCategory: 'Kategori Seçiniz',
              kdvLabel: 'Kdv',
              kdvPlaceholder: 'kdv...',
              selectBrand: 'Marka Seçiniz',
              brandModalTitle: 'Aradığınız markayı bulamadınız mı?',
              supportCall: 'Destek Çağrısı Oluştur',
              selectColor: 'Renk Seçiniz',
              selectStorage: 'Dahili Hafıza',
              productDescription: 'Ürün Açıklaması Giriniz',
              salesAndVariantInformation: 'SATIŞ VE VARYANT BİLGİLERİ',
              addNewVariant: 'Yeni Varyant Ekle',
              uploadButton: 'Upload',
              deleteButton: 'Sil',
              salesInformation: 'SATIŞ BİLGİLERİ',
              featureInformation: 'ÖZELLİK BİLGİLERİ',
              materialLabel: 'Malzeme',
              screenSizeLabel: 'Ekran Boyutu',
              productFeature: 'Ürün Özellik',
              featureModalTitle: 'Aradığınız özelliği bulamadınız mı?',
              product: 'Ürün',
              productImg: 'Görsel',
              color: 'Renk',
              memory: 'Hafıza',
              sellerStockCode: 'Satıcı Stok Kodu',
              variantGrupId: 'Varyant Grup ID',
              barcode: 'Barkod',
              idefixSalesPrice: 'Idefix Satış Fiyatı',
              lastUserPrice: 'Piyasa Satış Fiyatı',
              kdv: 'KDV',
              category: 'Kategori',
              amountOfStock: 'Stok Miktarı',
              estimatedDeliveryTime: 'Kargoya Teslim Süresi',
              operations: 'İşlemler',
              maxAmountStockInCart: 'Max Sepette Satılabilir Stok Adedi',
              width: 'En ',
              height: 'Yükseklik',
              size: 'Boy',
              weight: 'Ağırlık',
              desi: 'Desi',
              productAuditInformations: 'Ürün Denetim Bilgileri',
              originCountry: 'Menşei',
              ceCompatibility: 'CE Uygunluk Sembolü',
              importer: 'İthalatçı / Yetkili Temsilci / İfa Hizmet Sağlayıcı',
              manufacturer: 'Üretici Bilgisi',
              energyNutritionImage: 'Enerji ve Besin Değerleri Görseli',
              energyClassImage: 'Enerji Sınıfı Görseli',
              productInfoFormImage: 'Ürün Bilgi Formu Görseli',
              packageBackImage: 'Paket Görseli (Arka)',
              packageFrontImage: 'Paket Görseli (Ön)',
              usageInstructionsImage: 'Kullanım Talimatı/Uyarıları Görseli',
            },
            bulkOptions: {
              bulkOptions: 'TOPLU ÜRÜN İŞLEMLERİ',
              uploadOperation: 'ÜRÜN YÜKLEME ÖNİZLEMESİ',
              uploadPriceOperation: 'ÜRÜN GÜNCELLEME ÖNİZLEMESİ',
              uploadBrandOperation: 'MARKA YÜKLEME ÖNİZLEMESİ',
              successUploadOperation: 'Başarılı Yüklenen Ürünler',
              successUploadFastOperation: 'Başarılı Yüklenen Ürünler',
              uploadProcess: 'Yükleme İşlemleri',
              failedUploadOperation: 'Başarısız Yüklenen Ürünler',
              failedUploadFastOperation: 'Başarısız Yüklenen Ürünler',
              downloadExcelTitle: 'Excel hazırlamak için şablonu indirin.',
              productEntryWithExcel: 'Excel ile Ürün Girişi',
              productEntryWithExcelDesc: 'Kategori seçerek ürün girişi yapabilirsiniz.',
              fastProductMatchingWithExcel: 'Excel ile Hızlı Ürün Eşleştirme',
              vendorStockCodeUpdateExcel: 'Excel ile Satıcı Stok Kodu Güncelleme',
              dropshippingPriceEntryWithExcel: 'Excel ile Dropshipping Fiyat Girişi',
              uploadStock: 'Excel ile stok&fiyat güncelleme',
              uploadStockDesc: 'Barkod bilgisi girerek stok&fiyat güncellenebilir.',
              uploadProductInfo: 'Excel ile ürün bilgisi güncelleme',
              addBrandWithExcel: 'Excel ile Marka Ekleme',
              uploadProductInfoDesc: 'Ürüne ait görsel, açıklama, ismi ve rengi buybox da yer alıyor ise onaylanmayabilir.',
              deleteProduct: 'Ürün Silme',
              deleteProductDesc: 'Yalnızca onay bekleyen ve reddedilen ürünler silinebilir.',
              uploadExcel: 'Exceli sisteme yükle',
              selectCategory: 'KATEGORİ SEÇ',
              selectCategoryDesc: 'Yalnızca mağazanıza ürün eklemeye izin verilen kategoriler seçilebilir olacaktır.',
              categorySearchLabel: 'Arama',
              categorySearchPlaceholder: 'Kategori ara...',
              categoryName: 'Kategori Adı',
              selectButton: 'Seç',
              downloadButton: 'İndir',
              addImage: 'Dosya Ekle',
              uploadProductReview: 'Ürün Yükleme Önizlemesi',
              uploadProductPriceReview: 'ÜRÜN FİYAT GÜNCELLEME ÖNİZLEMESİ',
              product: 'Ürün Adi',
              color: 'Renk',
              memory: 'Hafıza',
              brand: 'Marka',
              productDesc: 'Ürün Açıklaması',
              sellerStockCode: 'Satıcı Stok Kodu',
              barcode: 'Barkod',
              idefixSalesPrice: 'Idefix Satış Fiyatı',
              recommendSalesPrice: 'Piyasa Satış Fiyatı',
              kdv: 'KDV',
              category: 'Kategori',
              amountOfStock: 'Stok Miktarı',
              estimatedDeliveryTime: 'Kargoya Teslim Süresi',
              operations: 'İşlemler',
              maxAmountStockInCart: 'Max Sepette Satılabilir Stok Adedi',
              width: 'En ',
              height: 'Yükseklik',
              size: 'Boy',
              weight: 'Ağırlık',
              desi: 'Desi',
              productImg: 'Görsel',
              deviceSize: 'Ekran Boyu',
              material: 'Materyal',
              warrantyPeriod: 'Garanti Süresi',
              status: 'Durum',
              addSelectedProducts: 'Seçilen Ürünleri Ekle',
              uploadSelectedProducts: 'Seçilenleri Güncelle',
              giveUp: 'Vazgeç',
              productAuditInformation: 'Excel ile Ürün Denetim Bilgisi Güncelle',
              productAuditInformationDownloadSuccess: 'Ürün Denetim Bilgisi Excel dosyası başarıyla indirildi.',
            },
            modals: {
              pleaseSelect: 'Lütfen seçin',
              addVariant: 'Varyant Ekle',
              addProduct: 'Ürün Ekle',
              selectColor: 'Renk Seçiniz',
              selectStorage: 'Hafıza Seçiniz',
              generalInformation: 'Genel Bilgiler',
              supportCallType: 'Destek Çağrı Tipi',
              brand: 'Marka',
              feature: 'Özellik',
              description: 'Açıklama',
              sendSupportCall: 'Destek Çağrısı Gönder',
              addProductImage: 'Ürün Görseli Ekle',
              turnSelection: 'Seçimi çevir',
              turnImage: 'Fotoğrafı çevir',
              okButton: 'Tamam',
              addImage: 'Görseli Ekle / Sürükle',
              imageType: '(JPG, JPEG, PNG)',
              uploadImg: 'Görselleri Yükle',
              addSingleProduct: 'Tekil Ürün Oluştur',
              bulkOptions: 'Toplu Ürün İşlemleri',
              supportCallTypeRequired: 'Lütfen destek çağrısı tipi seçiniz.',
              supportCallDescriptionRequired: 'Lütfen destek çağrısı açıklaması giriniz.',
            },
            poolProductDetail: {
              productInformation: 'ÜRÜN BİLGİLERİ',
              salesInformation: 'SATIŞ BİLGİLERİ',
              propertyInformation: 'ÖZELLİK BİLGİLERİ',
              productName: 'Ürün Adı',
              sellerStockNumber: 'Satıcı Stok Kodu',
              productMainId: 'Varyant Grup ID',
              barcode: 'Barkod',
              category: 'Kategori',
              brand: 'Marka',
              width: 'En',
              length: 'Boy',
              height: 'Yükseklik',
              weight: 'Ağırlık',
              desi: 'Desi',
              color: 'Renk',
              memory: 'Hafıza',
              smallInfo:
                "Buybox'ta yer alan ürünlerde yapılan güncellemeler ürünü satan tüm satıcıları etkilemektedir. Ürün ismi, görseli ve özelliklerinde yaptığımız güncellemeler onaylanmayabilir.",
              addImage: 'Görseli Ekle',
              drag: 'Sürükle',
              productDescription: 'Ürün Açıklaması',
              recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
              idefixPrice: 'İdefix Satış Fiyatı',
              stockQuantity: 'Stok Miktarı',
              commission: 'Komisyon',
              tax: 'KDV',
              estimatedDeliveryTime: 'Kargoya Teslim Süresi',
              maxNumberSalableProducts: 'Max Satılabilir Ürün Adeti',
              maxProductCanBeAddedToCard: 'Max Sepete Eklenebilir Ürün Adeti',
              material: 'Malzeme',
              deviceSize: 'Ekran Boyutu',
              productFeatures: 'Ürün Özellikleri',
              sendUpdateRequest: 'Güncelleme Talebi Gönder',
              sendApprove: 'Operatör Onayına Gönder',
            },
          },
          myProducts: {
            myProductsList: {
              myProducts: 'ÜRÜNLERİM',
              productManagement: 'ÜRÜN YÖNETİMİ',
              catalogProductListing: 'KATALOG ÜRÜN LİSTELEME',
              nameOfTheProduct: 'Ürün Adı',
              stockCode: 'Stok Kodu',
              barcode: 'Barkod',
              category: 'Kategori',
              noCategory: 'Kategori Bulunamadı',
              brand: 'Marka',
              noBrand: 'Marka Bulunamadı',
              missingInformationReason: 'Eksik Bilgi Nedeni',
              noReason: 'Neden Bulunamadı',
              productStatus: 'Ürün Durumu',
              search: 'ARA',
              column: 'Column',
              addProduct: 'Ürün Ekle',
              downloadExcel: 'Excel İndir',
              recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
              idefixSalesPrice: 'İdefix Satış Fiyatı',
              lowestPrice: 'En Düşük Fiyat',
              buyboxQueue: 'Buybox Sırası',
              stock: 'Stok',
              status: 'Durum',
              transactions: 'İşlemler',
              all: 'TÜMÜ',
              product: 'ÜRÜN',
              productsToReview: 'İNCELENECEK ÜRÜNLER',
              productsMissingInformation: 'EKSİK BİLGİLİ ÜRÜNLER',
              rejectedProducts: 'REDDEDİLMİŞ ÜRÜNLER',
              matchingProducts: 'EŞLEŞEN ÜRÜNLER',
              itemsRejectedMatch: 'EŞLEŞMESİ REDDEDİLEN ÜRÜNLER',
              productsInCatalog: 'KATALOG AŞAMASINDAKİ ÜRÜNLER',
              productsAvailableSale: 'SATIŞA HAZIR ÜRÜNLER',
              nonSaleProducts: 'SATIŞ DIŞI ÜRÜNLER',
              IDEProductCode: 'Idefix Ürün Kodu',
              categories: 'Kategori',
              creationDate: 'Oluşturulma Tarihi',
              dateOfUpdate: 'Güncelleme Tarihi',
            },
            addProductModal: {
              addProduct: 'ÜRÜN EKLE',
              addFromIdefixCatalog: 'İdefix Kataloğundan Ekle',
              createSingleProduct: 'Tekil Ürün Oluştur',
              bulkProductTransactions: 'Toplu Ürün İşlemleri',
            },
            matchConfirmationModal: {
              matchConfirmation: 'EŞLEŞME ONAYLAMA',
              sellerStockCode: 'Satıcı Stok Kodu',
              idefixSalesPrice: 'İdefix Satış Fiyatı',
              recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
              AmountOfStock: 'Stok Miktarı',
              estimatedDeliveryTime: 'Kargoya Teslim Süresi',
              approve: 'Onayla',
            },
          },
          productOperations: {
            pageTitle: 'ÜRÜN İŞLEMLERİ',
            pageDescription:
              "idefix'te ürün eklemek çok kolay! Tekil veya toplu ürün oluşturabilir, katalogdan hızlıca ürün seçebilir, onay süreçlerinin ardından hemen satışa başlayabilirsiniz.",
            addFromIdefixCatalog: 'idefix Kataloğundan Ürün Ekle',
            addFromIdefixCatalogDescription: 'İdefix’in kataloğundaki ürünleri, satış ve stok bilgilerini doldurarak satışa açmanızı sağlar.',
            addProductButton: 'Ürün Ekle',
            createProductButton: 'Ürün Oluştur',
            createSingleProduct: 'Tekil Ürün Oluştur',
            createSingleProductDescription: 'Benzersiz bir ürününüz var ise içerik detaylarını oluşturup ürününüzü satış için onaya göndermenizi sağlar.',
            createBulkProduct: 'Toplu Ürün İşlemleri',
            createBulkProductDescription: 'Excel ile toplu ürün oluşturma, toplu stok ve fiyat güncelleme gibi işlemlerinizi yapabilmenizi sağlar.',
          },
        },
        dashboard: {
          vendorReconciliation: {
            objectionModal: {
              title: 'Mutabakat İtirazı',
              reasonForObjection: 'İtiraz Sebebi',
              uploadTitle: 'Dosya Yükle',
              send: 'Gönder',
            },
          },
          sellerEvaluation: {
            title: 'Satıcı Puanı',
          },
          salesPerformanceSection: {
            salesPerformance: 'SATIŞ PERFORMANSIM',
            invoicedSales: 'FATURALANAN SATIŞLAR',
            yourNextPaymentDue: 'VADESİ GELEN GELECEK ÖDEMENİZ',
            comparisonOfSales: 'KARŞILAŞTIRMA SATIŞ ADETİ',
            incomingOrders: 'GELEN SİPARİŞ',
            salesToday: 'BUGÜNKÜ SATIŞ',
            lastOneWeek: 'SON 1 HAFTA',
            lastOneMonth: 'SON 1 AY',
            estimatedDailyTurnover: 'TAHMİNİ GÜNLÜK CİRO',
            today: 'BUGÜN',
            yesterday: 'DÜN',
            todayLastWeek: 'GEÇEN HAFTA BUGÜN',
            thisWeek: 'BU HAFTA',
            vehicles: 'ARAÇLAR',
          },
          operationPerformanceSection: {
            operationPerformance: 'OPERASYON PERFORMANSIM',
            dateRange: 'Tarih Aralığı',
            numberOfOrdersDelivered: 'TESLİM EDİLEN SİPARİŞ ADEDİ',
            numberOfOrdersShippingStage: 'KARGO AŞAMASINDAKİ SİPARİŞ ADEDİ',
            numberOfUndeliverableOrders: 'TESLİM EDİLEMEYEN SİPARİŞ ADEDİ',
            numberOfReturnsDuringShipping: 'KARGO AŞAMASINDAKİ İADE ADEDİ',
            numberOfOrdersWaitingToBeShipped: 'KARGOLANMAYI BEKLEYEN SİPARİŞ ADEDİ',
            overdueOrderQuantity: 'GECİKEN SİPARİŞ ADEDİ',
            pendingOrderQuantity: 'AÇIKTA BEKLEYEN SİPARİŞ ADEDİ',
            totalOrdersCount: 'TOPLAM SİPARİŞ ADEDİ',
            waitingForAction: 'AKSİYON BEKLEYENLER',
          },
          notificationsSection: {
            notifications: 'BİLDİRİMLER',
            unRead: 'Okunmamış',
            message: 'Mesaj',
            new: 'Yeni',
            unAnswered: 'Cevaplanmamış',
            productQuestion: 'Ürün Sorusu',
            delayedOrders: 'Geciken siparişleriniz var!',
            pendingOrders: 'İşlem bekleyen iadeleriniz var!',
            lowRatedProductsComment: 'Düşük puan alan ürün yorumları',
          },
          mySellerRatingTitle: 'SATICI PUANIM',
          mySellerRatingQuestions: 'Satıcı puanımı arttırmak için neler yapabilirim?',
          unansweredProductQuestions: 'CEVAPLANMAMIŞ ÜRÜN SORULARI',
          productReviews: 'ÜRÜN DEĞERLENDİRMELERİ',
          updatePrice: 'Fiyat Güncelle',
          updateStock: 'Stok Güncelle',
          bestSeller: 'ÇOK SATANLAR',
          activeCampaigns: 'AKTİF KAMPANYALAR',
          campaignsYouCanParticipate: 'KATILABİLECEĞİNİZ KAMPANYALAR',
          compete: 'Rekabet et',
          seeMore: 'Daha fazla gör',
        },
        userSettings: {
          pageTitle: 'KULLANICI YÖNETİMİ',
          userList: 'KULLANICI LİSTESİ',
          newUser: 'Yeni Kullanıcı Ekle',
          userRole: 'Kullanıcı Rolü',
          userSearch: 'Ara',
          nameLastname: 'Ad Soyad',
          phone: 'Cep No',
          email: 'E-Posta',
          role: 'Rolü',
          createdDate: 'Oluşturma Tarihi',
          updatedDate: 'Güncelleme Tarihi',
          state: 'Durum',
          process: 'İşlemler',
          edit: 'Düzenle',
          delete: 'Sil',
          deactive: 'Pasife Al',
          active: 'Aktif Et',
          newUserModal: {
            addUser: 'KULLANICI EKLE',
            firstName: 'Ad',
            lastName: 'Soyad',
            userNamePlaceholder: 'Kullanıcı adı giriniz',
            usernameRequired: 'Lütfen kullanıcı adını girin',
            email: 'Email',
            emailPlaceholder: 'Email giriniz',
            emailRequired: 'Lütfen email girin',
            emailInvalid: 'Lütfen geçerli bir email girin',
            phone: 'Cep No',
            phonePlaceholder: 'Telefon Numaranız',
            phoneRequired: 'Lütfen telefon numaranızı girin',
            role: 'Rol',
            rolePlaceholder: 'Lütfen seçin',
            roleRequired: 'Lütfen rol seçin',
          },
          editUserModal: {
            updateUser: 'KULLANICI DÜZENLE',
            firstName: 'Ad',
            lastName: 'Soyad',
            userNamePlaceholder: 'Kullanıcı adı giriniz',
            usernameRequired: 'Lütfen kullanıcı adını girin',
            email: 'Email',
            emailPlaceholder: 'Email giriniz',
            emailRequired: 'Lütfen email girin',
            emailInvalid: 'Lütfen geçerli bir email girin',
            phone: 'Cep No',
            phonePlaceholder: 'Telefon Numaranız',
            phoneRequired: 'Lütfen telefon numaranızı girin',
            role: 'Rol',
            rolePlaceholder: 'Lütfen seçin',
            roleRequired: 'Lütfen rol seçin',
          },
          editNameLastNameModal: {
            editUser: 'KULLANICI DÜZENLE',
            userName: 'Adı ve Soyadı',
          },
          deleteModal: {
            confirmTransaction: 'İŞLEMİ ONAYLA',
          },
          deactiveModal: {
            confirmTransaction: 'İŞLEMİ ONAYLA',
          },
        },
        commercialConditions: {
          pageTitle: 'TİCARİ KOŞULLAR',
          category: 'Kategori',
          brand: 'Marka',
          kdvCommission: 'Kdv Dahil Komisyon (%)',
          validityDate: 'Geçerlilik Tarihi',
          search: 'Ara',
          clear: 'Temizle',
          commissionTable: 'Komisyon Tablosu',
          sortOrder: 'Öncelik Sırası',
          vendorName: 'Satıcı',
          vendorCommission: 'Satıcı seviyesindeki komisyonları göster',
          expiredCommission: 'Geçerlilik süresi bitmiş komisyonları göster',
          productName: 'Ürün Adı',
          maturityTable: 'Vade Tablosu',
          maturity: 'Vade(Gün)',
          noOptionsMessage: 'Aradığınız kritere uygun değer bulunamadı',
        },
        notifications: {
          productQuestions: {
            pageTitle: 'BİLDİRİMLER',
            dateRange: 'Tarih Aralığı',
            isPopulerQuestion: 'Popüler soru mu ?',
            state: 'Durum',
            trademark: 'Marka',
            barcode: 'Barkod',
            myReadyAnswers: 'Hazır Cevaplarım',
            messageDate: 'Mesaj Tarihi',
            productInformation: 'Ürün Bilgileri',
            detail: 'Detay',
            isLive: 'Yayında mı?',
            process: 'İşlem',
          },
          orderQuestions: {
            pageTitle: 'BİLDİRİMLER',
            dateRange: 'Tarih Aralığı',
            state: 'Durum',
            trademark: 'Marka',
            barcode: 'Barkod',
            myReadyAnswers: 'Hazır Cevaplarım',
            orderNumber: 'Sipariş No',
            customer: 'Müşteri',
            detail: 'Detay',
            process: 'İşlem',
            subject: 'Konu',
            clean: 'Temizle',
            downloadExcel: 'Excel İndir',
            startDate: 'Başlangıç Tarihi',
            endDate: 'Bitiş Tarihi',
          },
          productReviews: {
            pageTitle: 'BİLDİRİMLER',
            dateRange: 'Tarih Aralığı',
            state: 'Durum',
            trademark: 'Marka',
            productNameBarCode: 'Ürün ismi / Barkod',
            category: 'Kategori',
            productInformation: 'Ürün Bilgileri',
            createdDate: 'Oluşturulma Tarihi',
            averageProductRating: 'Ortalama Ürün Puanı',
            showCommentsOnly: 'Yalnızca yorumları göster',
            rating: 'Puan',
            comment: 'Yorum',
          },
          orderReviews: {
            pageTitle: 'BİLDİRİMLER',
            dateRange: 'Tarih Aralığı',
            trademark: 'Marka',
            barcode: 'Barkod',
            category: 'Kategori',
            orderInformation: 'Sipariş Bilgileri',
            evaluationDate: 'Değerlendirme Tarihi',
            evaluationScore: 'Değerlendirme Puanı',
            ratingAndComment: 'Puan ve Yorumlar',
            showCommentsOnly: 'Yalnızca yorumları göster',
            comments: 'Yorumlar',
            rating: 'Puan',
            comment: 'Yorum',
          },
          announcements: {
            pageTitle: 'BİLDİRİMLER',
            detail: 'Detay',
            dateRange: 'Tarih Aralığı',
          },
          operationMessages: {
            pageTitle: 'BİLDİRİMLER',
            operationMessages: 'Operasyon Mesajları',
            dateRange: 'Tarih Aralığı',
            detail: 'Detay',
          },
          readyOrders: {
            pageTitle: 'BİLDİRİMLER',
            createCannedAnswer: 'Hazır Cevap Oluştur',
            title: 'Başlık',
            text: 'Metin',
            process: 'İşlemler',
          },
          readyProducts: {
            pageTitle: 'BİLDİRİMLER',
            createCannedAnswer: 'Hazır Cevap Oluştur',
            title: 'Başlık',
            text: 'Metin',
            process: 'İşlemler',
          },
        },

        campaigns: {
          campaignInfoModal: {
            title: 'Kampanya Bilgileri',
            campaignScope: {
              1: 'Tümü',
              2: 'Marka ve/veya Kategori',
              3: 'Belli Ürünlerim için',
            },
          },
          mainCampaigns: {
            centerCampaigns: {
              all: 'Tümü',
              campaignManagement: 'Kampanya Yönetimi',
              myCampaigns: 'Kampanyalarım',
              campaignList: 'Kampanya Liste',
              campaignName: 'Kampanya Adı',
              campaignDate: 'Geçerlilik Tarihi',
              campaignType: 'Kampanya Türü',
              campaignStatus: 'Kampanya Statüsü',
              campaignState: 'Kampanya Durum',
              campaignConditions: 'Kampanya Koşulları',
              createNewCampaign: 'Yeni Kampanya Oluştur',
              search: 'Ara',
              description: 'Açıklama',
              date: 'Kampanya Tarihi',
              createdDate: 'Oluşturulma Tarihi',
              productScope: 'Ürün Kapsamı',
              availableCampaign: 'Kampanya Uygunluğu',
              onlyShow: 'Sadece Katıldıklarımı Göster',
            },
            myCampaigns: {
              myCampaigns: 'Kampanyalarım',
              campaignList: 'Kampanya Liste',
              campaignDate: 'Geçerlilik Tarihi',
              availableCampaign: 'Kampanya Uygunluğu',

              campaignName: 'Kampanya Adı',
              campaignType: 'Kampanya Tipi',
              campaignStatus: 'Kampanya Durumu',
              campaignConditions: 'Kampanya Koşulları',
              createNewCampaign: 'Yeni Kampanya Oluştur',
              search: 'Ara',
              description: 'Açıklama',
              date: 'Tarih',
              productScope: 'Ürün Kapsamı',
              onlyShow: 'Sadece Katıldıklarımı Göster',
            },
          },
          createCampaigns: {
            main: {
              createCampaign: 'Kampanya Oluştur',
              editCampaign: 'Kampanya Düzenle',
              campaignInfo: 'Kampanya Bilgileri',
              campaignScope: 'Kampanya Kapsamı',
              campaignExcept: 'Kampanya Hariç',
              campaignCriteria: 'Kampanya Kriterleri',
              description: 'Açıklama',
              back: 'Geri Git',
              continue: 'Devam Et',
              approve: 'Onayla',
              update: 'Güncelle',
            },
            stepCampaignInformation: {
              campaignName: 'Kampanya Adı',
              description: 'Kampanya Açıklaması',
              frontendDescription: 'Önyüzde Gösterilecek Açıklama',
              campaignType: 'Kampanya Türü',
              discountCoupon: 'İndirim Kuponu',
              budget: 'Kampanya Bütçesi',
              discount: 'İndirim Kuponu',
              date: 'Geçerlilik Tarihi',
              state: 'Durum',
              numberOfWorks: 'Kampanyanın Çalışma Adedi',
              maxBenefit: 'Max Fayda',
              minProductQuantity: 'Sepete Eklenecek Min Ürün Adedi',
              selectCampaignType: 'Kampanya Türünü Seçiniz',
              priceDiscountInBasket: 'Sepette Fiyat İndirimi',
              getXPayY: 'X Al Y Öde',
              takeItTogether: 'Birlikte Al',
              percentDiscountInBasket: 'Sepette Yüzde İndirimi',
              buyALotPayLess: 'Çok Al Az Öde',
              discountOnTheXthItem: "X'inci Ürüne İndirim",
            },
            stepCampaignScope: {
              allProducts: 'Tüm Ürünlerim',
              brandAndCategory: 'Marka ve/veya Kategori',
              chooseCategory: 'Kategori Seçim',
              chooseBrand: 'Marka Seçim',
              chooseProduct: 'Ürün Seçim',
              excel: 'Excel ile yükle',
              someProducts: 'Belli Ürünlerim için',
              includingCampaign: 'Kampanyaya Dahil Edilecek Ürünler',
              productName: 'Ürün Adı',
              productCode: 'Ürün Kodu',
              barcode: 'Barkod',
              productStatus: 'Durum',
              except: 'Kampanyadan Hariç Tutmak İstediğiniz Ürünler',
              searchProductOrBrand: 'Ürün arayınız',
            },
            stepCampaignExcept: {
              allProducts: 'Hiç Bir Ürün',
              brandAndCategory: 'Marka ve/veya Kategori',
              infoFirst: 'Bu seçenek, kampanya oluştururken belirleyeceğiniz',
              infoBold: ' markaların, kategorilerin veya ürünlerin',
              infoLast: ' kampanya dışında tutulmasını sağlar.',
              chooseCategory: 'Kategori Seçim',
              chooseBrand: 'Marka Seçim',
              chooseProduct: 'Ürün Seçim',
              excel: 'Excel ile yükle',
              someProducts: 'Belli Ürünlerim için',
              includingCampaign: 'Kampanyadan Hariç Tutmak İstediğiniz Ürünler',
              productName: 'Ürün Adı',
              productCode: 'Ürün Kodu',
              barcode: 'Barkod',
              productStatus: 'Durum',
              except: 'Kampanyadan Hariç Tutmak İstediğiniz Ürünler',
              searchProductOrBrand: 'Ürün arayınız',
            },
            stepCampaignCriteria: {
              percentDiscountInBasket: 'Sepette Yüzde İndirim',
              costBasket: 'Sepet Tutarı',
              pieceBasket: 'Ürün Adedi',
              discountPercent: 'İndirim Oranı',
              costDiscount: 'İndirim Tutarı',
              piece: 'Adet',
              maxBenefit: 'Max Fayda',
              tlDiscount: 'Sepette TL İndirim',
              addCondition: 'Koşul Ekle',
              conditionNumber: 'Koşul Adedi',
              earnNumber: 'Hakediş Adedi',
              orderNumber: 'Sipariş Adet',
              productPriceCampaign: 'Ürün Fiyat Kampanyası',
              shippingPrice: 'Kargo Bedeli',
              freeShipping: 'Ücretsiz Kargo',
              budget: 'Kampanya Bütçesi',
              pushToPrice: 'Kampanya fiyatı ürünün gönderilen fiyatını ezsin mi ?',
              oneTime: 'Bu kampanya sepette yalnızca 1 kere uygulanabilir.',
            },
            step4: {
              campaignSummary: 'Kampanya Özeti',
              campaignScope: {
                1: 'Tümü',
                2: 'Marka ve/veya Kategori',
                3: 'Belli Ürünlerim için',
              },
            },
            basketDiscount: {
              priceDiscountInBasket: 'Sepette Fiyat İndirimi',
              percentDiscount: 'Sepette Yüzde İndirimi',
              conditionAdd: 'Barem/Koşul Ekle',
              costBasket: 'Sepet Tutarı',
              pieceBasket: 'Ürün Adedi',
              costDiscount: 'İndirim Tutarı',
              piece: 'Adet',
              maxBenefit: 'Max Fayda',
              tlDiscount: 'Sepette TL İndirim',
              addCondition: 'Koşul Ekle',
              conditionNumber: 'Koşul Adedi',
              earnNumber: 'Hakediş Adedi',
              orderNumber: 'Sipariş Adet',
              productPriceCampaign: 'Ürün Fiyat Kampanyası',
              shippingPrice: 'Kargo Bedeli',
              freeShipping: 'Ücretsiz Kargo',
              budget: 'Kampanya Bütçesi',
              pushToPrice: 'Kampanya fiyatı ürünün gönderilen fiyatını ezsin mi ?',
              oneTime: 'Bu kampanya sepette yalnızca 1 kere uygulanabilir.',
              orderPieceLimit: 'Sipariş Adedi Limiti',
            },
            basketDiscountPercentage: {
              percentDiscount: 'Sepette Yüzde İndirimi',
              conditionAdd: 'Barem/Koşul Ekle',
              costBasket: 'Sepet Tutarı',
              pieceBasket: 'Ürün Adedi',
              orderPieceLimit: 'Sipariş Adedi Limiti',
              discountPercent: 'İndirim Oranı',
              costDiscount: 'İndirim Tutarı',
              piece: 'Adet',
              maxBenefit: 'Max Fayda',
              tlDiscount: 'Sepette TL İndirim',
              addCondition: 'Koşul Ekle',
              conditionNumber: 'Koşul Adedi',
              earnNumber: 'Hakediş Adedi',
              orderNumber: 'Sipariş Adet',
              productPriceCampaign: 'Ürün Fiyat Kampanyası',
              shippingPrice: 'Kargo Bedeli',
              freeShipping: 'Ücretsiz Kargo',
              budget: 'Kampanya Bütçesi',
              pushToPrice: 'Kampanya fiyatı ürünün gönderilen fiyatını ezsin mi ?',
              oneTime: 'Bu kampanya sepette yalnızca 1 kere uygulanabilir.',
            },
            getXPayY: {
              numberOfProgressPayments: 'Satın alınması gereken ürün adedi',
              paidByTheCustomer: 'Müşterinin ödeyeceği ürün adedi',
              orderPieceLimit: 'Sipariş Adedi Limiti',
              getXPayYCampaing: 'X al Y Öde Kampanyası',
              percentDiscount: 'Sepette Yüzde İndirimi',
              percentDiscountInBasket: 'Sepette Fiyat İndirimi',
              brandAndCategory: 'Marka, kategori ve/veya katalog',
              specificProducts: 'Belirli ürünler için',
              setPricePromotionalProduct: 'Kampanyalı ürün fiyatını belirle',
              pricePromotionalProduct: 'Kampanyalı ürün fiyatı',
              costBasket: 'Sepet Tutarı',
              conditionAdd: 'Barem/Koşul Ekle',
              pieceBasket: 'Ürün Adedi',
              discountPercent: 'İndirim Oranı',
              costDiscount: 'İndirim Tutarı',
              blockReturn: 'Yalnızca blok iade yapılabilir.',
              chooseCategory: 'Kategori Seçim',
              chooseBrand: 'Marka Seçim',
              campaignProductSelection: 'Kampanyalı Ürün İçin Ürün Seçimi',
            },
            bundleProductCampaign: {
              numberOfCriteria: 'Kriter Adedi',
              numberOfProgressPayments: 'Hakediş Adedi',
              selectAwardProduct: 'Ödül ürününü seçiniz',
              productName: 'Ürün Adı',
              productCode: 'Ürün Kodu',
              barcode: 'Barkod',
              excel: 'Alternatifli ödül ürünleri yükle',
              percentDiscount: 'Sepette Yüzde İndirimi',
              percentDiscountInBasket: 'Sepette Fiyat İndirimi',
              brandAndCategory: 'Marka, kategori ve/veya katalog',
              specificProducts: 'Belirli ürünler için',
              setPricePromotionalProduct: 'Kampanyalı ürün fiyatını belirle',
              pricePromotionalProduct: 'Kampanyalı ürün fiyatı',
              costBasket: 'Sipariş Adeti Limiti',
              pieceBasket: 'Ürün Adedi',
              discountPercent: 'İndirim Oranı',
              prizeProductPrice: 'Ödül ürününün fiyatı',
              costDiscount: 'İndirim Tutarı',
              blockReturn: 'Yalnızca blok iade yapılabilir.',
              chooseCategory: 'Kategori Seçim',
              chooseBrand: 'Marka Seçim',
              campaignProductSelection: 'Bundle Ürün İçin Ürün Seçimi',
              searchProductOrBrand: 'Ürün ya da Markayı arayınız',
              search: 'Arayın',
              discount: {
                tl: 'Ödül ürününe TL indirimi',
                percent: 'Ödül ürününe yüzde indirimi',
                price: 'Ödül ürününün fiyatını belirle',
              },
            },
            buyALotPayLess: {
              numberOfCriteria: 'Kriter Adedi',
              numberOfProgressPayments: 'Hakediş Adedi',
              buyALotPayLessCampaing: 'Çok Al Az Öde Kampanyası',
              percentDiscount: 'Sepette Yüzde İndirimi',
              percentDiscountInBasket: 'Sepette Fiyat İndirimi',
              setPricePromotionalProduct: 'Kampanyalı ürün fiyatını belirle',
              pricePromotionalProduct: 'Kampanyalı ürün fiyatı',
              costBasket: 'Sepet Tutarı',
              pieceBasket: 'Ürün Adedi',
              discountPercent: 'İndirim Yüzdesi',
              orderPieceLimit: 'Sipariş Adedi Limiti',
              costDiscount: 'İndirim Tutarı',
              blockReturn: 'Yalnızca blok iade yapılabilir.',
              chooseCategory: 'Kategori Seçim',
              chooseBrand: 'Marka Seçim',
              campaignProductSelection: 'Bundle Ürün İçin Ürün Seçimi',
              conditionAdd: 'Barem/Koşul Ekle',
            },
            buyXPayY: {
              yTl: "X'inci Ürün Y TL",
              discountTl: "X'inci Ürüne Y TL İndirim",
              discountPercent: "X'inci Ürüne %Y İndirim",
              productToBeApplied: 'Uygulanacak Ürün',
              productPrice: 'Ürün Fiyatı',
              discountAmount: 'İndirim Tutarı',
              discountRate: 'İndirim Oranı',
              orderQuantityLimit: 'Sipariş Adedi Limiti',
              thProduct: ' . Ürüne',
            },
          },
          couponGiftCard: {
            coupon: {
              myDiscountCoupons: 'İndirim Kuponlarım',
              dateRange: 'Başlangıç / Bitiş Tarihi',
              couponBudget: 'Kupon Bütçesi',
              amountLowerLimit: 'Tutar / Alt Limit',
              numberOfCouponsWon: 'Kazanılan Kupon Sayısı',
              usedCoupon: 'Kullanılan Kupon',
              numberOfCouponsThatCanBeUsed: 'Kullanılabilecek Kupon Sayısı',
              couponName: 'Kupon Adı',
              date: 'Tarih Aralığı',
              relatedCampaigns: 'Bağlı Kampanyalar',
              status: 'Durum',
              totalCoupon: 'Toplam Kupon',
              couponStatus: 'Kupon Durumu',
              search: 'Ara',
              createNewCoupon: 'Yeni Kupon Oluştur',
              actions: 'Aksiyon',
              all: 'Tümü',
            },
            newCoupon: {
              createNewCoupon: 'Yeni Kupon Oluştur',
              editCoupon: 'Kupon Düzenle',
              couponName: 'Kupon Adı',
              giftCard: 'İndirim Kuponu',
              discountCard: 'İndirim Kuponu',
              couponInformation: 'Kupon Bilgileri',
              couponMass: 'Kupon Kapsamı',
              couponExcept: 'Kupon Hariç',
              couponBudget: 'Kupon Bütçesi',
              approve: 'Onayla',
              approveBtnText: 'Onayla ve kupon oluştur',
              updateBtnText: 'Güncelle',
              continue: 'Devam Et',
              back: 'Geri',
              stepCouponInformationSchema: {
                couponName: 'Kupon Adı',
                enterCouponName: 'Kupon adı giriniz',
                selectCouponMass: 'Kupon Kitlesini Seçiniz',
                couponMass: {
                  onlyFollowers: 'Mağazanızı Takip Edenlere Özel',
                  all: 'Tüm Müşterilere Açık',
                },
                date: 'Geçerlilik Tarihi',
              },
              stepCouponScope: {
                selectCouponScope: 'Kupon Kapsamını Seçiniz',
                allProducts: 'Tüm Ürünlerim',
                onlySelectedBrandsOrCategories: 'Marka ve/veya kategori',
                chooseCategory: 'Kategori Seçim',
                chooseBrand: 'Marka Seçim',
                chooseProduct: 'Ürün Seçim',
                excel: 'Excel ile yükle',
                someProducts: 'Belli Ürünlerim için',
                includingCampaign: 'Kampanyaya Dahil Edilecek Ürünler',
                productName: 'Ürün Adı',
                productCode: 'Ürün Kodu',
                barcode: 'Barkod',
                productStatus: 'Durum',
                except: 'Kampanyadan Hariç Tutmak İstediğiniz Ürünler',
                searchProductOrBrand: 'Ürün arayınız',
              },
              stepCouponExcept: {
                selectCouponExcept: 'Kupon Haricini Seçiniz',
                infoFirst: 'Bu seçenek, kupon oluştururken belirleyeceğiniz',
                infoBold: ' markaları, kategorileri veya ürünleri',
                infoLast: ' kupon kapsamı dışında tutulmasını sağlar.',
                allProducts: 'Hiç Bir Ürün',
                onlySelectedBrandsOrCategories: 'Marka ve/veya kategori',
                chooseCategory: 'Kategori Seçim',
                chooseBrand: 'Marka Seçim',
                chooseProduct: 'Ürün Seçim',
                excel: 'Excel ile yükle',
                someProducts: 'Belli Ürünlerim için',
                includingCampaign: 'Kampanyaya Dahil Edilecek Ürünler',
                productName: 'Ürün Adı',
                productCode: 'Ürün Kodu',
                barcode: 'Barkod',
                productStatus: 'Durum',
                except: 'Kampanyadan Hariç Tutmak İstediğiniz Ürünler',
                searchProductOrBrand: 'Ürün arayınız',
              },
              stepCouponBudget: {
                couponPiece: 'Kupon Adedi',
                enterCouponPiece: 'Kupon adedi giriniz',
                couponAmount: 'Kupon Tutarı',
                enterCouponAmount: 'Kupon tutarı giriniz',
                shoppingBottomLimit: 'Alışveriş Alt Limiti',
                enterShoppingBottomLimit: 'Alışveriş alt limiti giriniz',
                couponBudget: 'Kupon Bütçesi',
                couponAmountOptions: {
                  currency: 'TL',
                },
              },
              stepCouponConfirmation: {
                couponSummary: 'Kupon Özeti',
                currency: 'TL',
                couponScopeLabel: {
                  all: 'Tüm ürünler',
                  selected: 'Seçilen Kategori(ler) ve Marka(lar)',
                  someProducts: 'Belli Ürünlerim için',
                  unselected: 'Henüz bununla ilgili seçim yapılmamış.',
                },
              },
            },
          },
          commissionOffers: {
            pageTitle: 'KOMİSYON TEKLİFLERİM',
            productInformation: 'Ürün Bilgileri',
            previousStatus: 'Önceki Durum',
            currentStatus: 'Güncel Durum',
            offer: 'Teklif',
            barcode: 'Barkod',
            currentStock: 'Mevcut Stok',
            enteredPrice: 'Girilen Fiyat',
            enterPrice: 'Fiyat Gir',
            commission: 'Komisyon',
            noResultMessage: 'Sonuç bulunamadı.',
            dataErrorMessage: 'Veriler alınırken bir hata ile karşılaşıldı.',
            enterPriceModal: {
              enterPrice: 'Fiyat Gir',
              updatePrice: 'Fiyatı Güncelle ve Teklifi Kabul Et',
              priceErrorMessage: 'Lütfen teklife eşit ya da daha düşük bir fiyat giriniz.',
            },
            tabs: {
              commissionOffers: 'Komisyon Tekliflerim',
              acceptedCommissionOffers: 'Kabul Edilen Teklifler',
            },
          },
        },
        inventory: {
          pageTitle: 'Envanter',
          allInventory: 'TÜMÜ',
          allProducts: 'ÜRÜNLERİM',
          onSale: 'SATIŞTA',
          closeSale: 'SATIŞA KAPALI',
          offSale: 'SATIŞ DIŞI',
          locked: 'KİLİTLİ',
          dropshipping: 'DROP ÜRÜNLER',
          noLockReasonMessage: 'Aradığnız kritere uygun kilit nedeni bulunamadı',
          noCloseReasonMessage: 'Aradığınız kritere uygun kapama nedeni bulunamadı',
          clean: 'Temizle',
          search: 'ARA',
          downloadExcel: 'Excel İndir',
          startDate: 'Başlangıç Tarihi',
          expiryDate: 'Bitiş Tarihi',
          notFoundTexts: {
            byFilter: 'Filtrenize uygun ürün bulunamadı.',
            all: 'Ürün bulunamadı.',
            active: 'Satışa ürün bulunmamakta.',
            closed: 'Satışa kapalı ürün bulunmamakta.',
            dropshipping: 'Dropshipping ürün bulunmamakta.',
            offSale: 'Satış dışı ürün bulunmamakta.',
            passive: 'Kilitli ürün bulunmamakta.',
          },
          allList: {
            whatShouldIDoNow: 'Şimdi Ne Yapmalıyım ?',
            lockdate: 'Kilitleme Tarihi',
            inventory: 'ENVANTER',
            nameOfTheProduct: 'Ürün Adı',
            stockCode: 'Stok Kodu',
            barcode: 'Barkod',
            category: 'Kategori',
            noCategoryMessage: 'Aradığınız kritere uygun kategori bulunamadı',
            brand: 'Marka',
            noBrandMessage: 'Aradığınız kritere uygun marka bulunamadı',
            lockReason: 'Kilit Nedeni',
            closeReason: 'Kapama Nedeni',
            noCloseReasonMessage: 'Aradığınız kritere uygun kapama nedeni bulunamadı',
            maturity: 'Vade',
            productStatus: 'Ürün Durumu',
            search: 'ARA',
            column: 'Column',
            addProduct: 'Ürün Ekle',
            downloadExcel: 'Excel İndir',
            recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
            shippingDate: 'Kargoya Teslim Tarihi',
            idefixSalesPrice: 'İdefix Satış Fiyatı',
            lowestPrice: 'En Düşük Fiyat',
            buyboxQueue: 'Buybox Sırası',
            stock: 'Stok',
            maximumPurchasableQuantity: 'Max. Sepete Eklenebilir Ürün Adedi',
            status: 'Durum',
            regionalSale: 'Bölgesel Satış',
            transactions: 'İşlemler',
            all: 'TÜMÜ',
            IDEProductCode: 'IDE Ürün Kodu',
            categories: 'Kategori',
            creationDate: 'Oluşturulma Tarihi',
            dateOfUpdate: 'Güncelleme Tarihi',
            commission: 'Komisyon',
            vat: 'KDV',
            deliveryTimeToCargo: 'Kargoya Teslim Süresi',
            shippingCompany: 'Kargo Şirketi',
            productsOutOfStock: 'Stoğu olmayan ürünler',
            productsWithDecreasingStock: 'Stoğu azalan ürünler',
          },
          dropShippingList: {
            whatShouldIDoNow: 'Şimdi Ne Yapmalıyım ?',
            lockdate: 'Kilitleme Tarihi',
            inventory: 'ENVANTER',
            nameOfTheProduct: 'Ürün Adı',
            stockCode: 'Stok Kodu',
            barcode: 'Barkod',
            category: 'Kategori',
            noCategoryMessage: 'Aradığınız kritere uygun kategori bulunamadı',
            brand: 'Marka',
            noBrandMessage: 'Aradığınız kritere uygun marka bulunamadı',
            noPriceTypeMessage: 'Aradığınız kritere uygun fiyatlandırma tipi bulunamadı',
            lockReason: 'Kilit Nedeni',
            noLockReasonMessage: 'Aradığınız kritere uygun kilit nedeni bulunamadı',
            closeReason: 'Kapama Nedeni',
            noCloseReasonMessage: 'Aradığınız kritere uygun kapama nedeni bulunamadı',
            maturity: 'Vade',
            productStatus: 'Ürün Durumu',
            search: 'ARA',
            column: 'Column',
            addProduct: 'Ürün Ekle',
            downloadExcel: 'Excel İndir',
            recommendedEndUserPrice: 'Piyasa Satış Fiyatı',
            shippingDate: 'Kargoya Teslim Tarihi',
            idefixSalesPrice: 'İdefix Satış Fiyatı',
            drSalesPrice: 'D&R Satış Fiyatı',
            drPurchasePrice: 'D&R Alış Fiyatı',
            pricingType: 'Fiyatlandırma Tipi',
            price: 'Fiyat',
            correctionNet: 'Düzeltme Neti',
            percentFactor: 'Yüzde Çarpanı',
            markDropShippingDate: 'Drop Olarak İşaretleme Tarihi',
            updateDropShippingDate: 'Drop Fiyat Güncelleme Tarihi',
            margin: 'Marj',
            lowestPrice: 'En Düşük Fiyat',
            buyboxQueue: 'Buybox Sırası',
            stock: 'Stok',
            maximumPurchasableQuantity: 'Max. Sepete Eklenebilir Ürün Adedi',
            status: 'Durum',
            regionalSale: 'Bölgesel Satış',
            transactions: 'İşlemler',
            all: 'TÜMÜ',
            IDEProductCode: 'IDE Ürün Kodu',
            categories: 'Kategori',
            creationDate: 'Oluşturulma Tarihi',
            dateOfUpdate: 'Güncelleme Tarihi',
            commission: 'Komisyon',
            vat: 'KDV',
            deliveryTimeToCargo: 'Kargoya Teslim Süresi',
            shippingCompany: 'Kargo Şirketi',
            productsOutOfStock: 'Stoğu olmayan ürünler',
            productsWithDecreasingStock: 'Stoğu azalan ürünler',
          },
          inventoryFilter: {
            product: 'Ürün',
            all: 'Tümü',
            openForSale: 'SATIŞTA',
            closedForSale: 'SATIŞA KAPALI',
            notForSale: 'SATIŞ DIŞI',
            locked: 'KİLİTLİ',
          },
          inventoryLockedList: {
            inventory: 'ENVANTER',
            nameOfTheProduct: 'Ürün Adı',
            stockCode: 'Stok Kodu',
            barcode: 'Barkod',
            category: 'Kategori',
            noCategoryMessage: 'Aradığınız kritere uygun kategori bulunamadı',
            brand: 'Marka',
            noBrandMessage: 'Aradığınız kritere uygun marka bulunamadı',
            search: 'ARA',
            column: 'Column',
            addProduct: 'Ürün Ekle',
            downloadExcel: 'Excel İndir',
            lockReason: 'Kilit Nedeni',
            noLockReasonMessage: 'Aradığınız kritere uygun kilit nedeni bulunamadı',
            whatShouldIDoNow: 'Şimdi Ne Yapmalıyım ?',
            lockdate: 'Kilitleme Tarihi',
            status: 'Durum',
            transactions: 'İşlemler',
          },
          unlockModal: {
            unlock: 'KİLİDİ KALDIR',
            nameOfTheProduct: 'Ürün Adı:',
            IDEProductCode: 'IDE Ürün Kodu:',
            status: 'Durum:',
            lockReason: 'Kilit Nedeni:',
            whatShouldIDoNow: 'Şimdi Ne Yapmalıyım ?',
            productSalesPrice: 'Ürün Satış Fiyatı(KDV Dahil)',
          },
          updateProductInformationModal: {
            title: 'Ürün Bilgileri Güncelleme Talebi',
            description: 'Ürün adı, açıklaması, desi bilgisi, ürün kdv bilgisi, görseli ve video güncelleme talebinde bulunabilirsiniz.',
            updateArea: 'Güncellenecek Alan:',
            updateAreaRequired: 'Lütfen güncellenecek alanı seçin',
            valueRequired: 'Lütfen değer belirtin.',
            choose: 'Seçiniz',
            productTitle: 'Ürün Adı',
            productDescription: 'Ürün Açıklaması',
            productImageAdd: 'Ürün Görseli Ekleme',
            productImageDelete: 'Ürün Görseli Silme',
            productVideoRecord: 'Ürün Video Kaydı',
            productDesiInformation: 'Ürün Desi Bilgisi',
            sendUpdateRequest: 'Güncelleme Talebi Gönder',
            productVatRateInfromation: 'Ürün KDV Bilgisi',
            productFeature: 'Ürün Özelliği',
          },
          dropShippingModal: {
            markTitle: 'Drop Ürünü Olarak İşaretle',
            updateTitle: 'Drop Ürün Fiyat Güncelle',
            removeTitle: 'Drop Ürün Durumunu Kaldır',
            removeText: 'Ürününüz Drop üründen kaldırılacaktır. Devam etmek istiyor musunuz?',
            markSuccessMessage: 'Ürün Drop olarak işaretlendi.',
            updateSuccessMessage: 'Ürünün Drop fiyatı güncellendi.',
            removeSuccessMessage: 'Ürün Drop durumundan kaldırıldı.',
            productName: 'Ürün Adı:',
            barcode: 'Barkod',
            pricingType: 'Fiyatlama Tipi',
            price: 'Fiyat (Drop)',
            salesPrice: 'idefix Satış Fiyatı',
            correctionNet: 'Düzeltme Neti',
            percentFactor: 'Yüzde Çarpanı',
            sendMarkRequest: 'Kaydet',
          },
          uploadImage: {
            imageTitle: 'Resim Yükle',
            videoTitle: 'Video Yükle',
            addImage: 'Dosyaları yüklemek için buraya bırakın veya tıklayın.',
          },
          fillRateInformation: {
            status: {
              weak: 'Zayıf',
              medium: 'Orta',
              strong: 'Güçlü',
            },
          },
        },
        finance: {
          dashboard: {
            financeScreen: 'FİNANS EKRANI',
            vesting: 'Hak Ediş',
            estimatedPaymentDate: 'Tahmini Ödeme Tarihi',
            order: 'Sipariş',
            commission: 'Komisyon',
            shipping: 'Kargo',
            punishment: 'Ceza',
            other: 'Diğer',
            paymentPrice: 'Ödenecek Tutar',
            paymentAndVesting: 'Hak ediş - Ödemeler',
            income: 'Gelirler',
            outcome: 'Giderler',
            passedIncome: 'Geçmiş Ödemeler',
            totalPayment: 'Toplam Ödeme Tutarı',
            detail: 'Detay',
            filter: 'Filtrele',
            paymentNumber: 'Ödeme No',
            seller: 'Satıcı',
            ibanFromPayment: 'Ödeme Yapılan IBAN',
            account: 'Hesap Sahibi',
            paymentDate: 'Ödeme Tarihi',
            cost: 'Tutar',
            status: 'Durum',
            detailBar: 'Aksiyon',
            future: 'Gelecek Dönem Hak Edişler',
            paymentDetails: 'Ödeme Detay',
            processType: 'İşlem Tipi',
            deliveryNumber: 'Sevkiyat No',
            orderNumber: 'Sipariş Kalem No',
            orderDate: 'İşlem Tarihi',
            lastCost: 'Net Tutar',
          },
          vesting: {
            vesting: 'HAK EDİŞ',
            processType: 'İşlem Tipi',
            searchByProcessType: 'İşlem Tipine göre',
            searchByProcessDate: 'Tarih Aralığına göre',
            searchByVestingDate: 'Hakediş Tarihine göre',
            searchByOrderDate: 'Sipariş Tarihine göre',
            selectTransactionType: 'İşlem Tipini Seçiniz',
            filter: 'Filtrele',
            downloadExcel: 'Excel İndir',
            no: 'No',
            orderDate: 'İşlem Tarihi',
            vestingDate: 'Hakediş Tarihi',
            detail: 'Detay',
            couponCost: 'Kupon Tutar',
            orderTotal: 'Sipariş Toplam',
            orderNumber: 'Sipariş No',
            cancelCost: 'İptal Tutar',
            returnCost: 'İade Tutar',
            supplierCost: 'Tedarikçi Tutar',
            commission: 'Komisyon',
            commissionY: 'Komisyon %',
            paymentDate: 'Ödeme Tarihi',
            registrationNumber: 'Kayıt No',
            shippingInfo: 'Sipariş Bilgileri',
            shippingDate: 'Sipariş Tarihi',
            shipmentNumber: 'Sevkiyat Numarası',
            shippingNumber: 'Sevkiyat No',
            billNnumber: 'Fatura No',
            Registrar: 'Kayıt Sahibi',
            progressPaymentDate: 'Hakediş Tarihi',
            progressPayment: 'Hakediş',
            total: 'Toplam',
            paymentStatus: 'Ödeme Durumu',
            clean: 'Temizle',
          },
          invoices: {
            invoices: 'FATURALAR',
            serviceType: 'Fatura Tipi',
            period: 'Dönem',
            shippingInvoices: 'Kargo Faturası',
            commissionInvoices: 'Komisyon Faturası',
            commissionReturn: 'Komisyon İadesi',
            date: 'Tarih Aralığı',
            filter: 'Filtrele',
            invoiceNumber: 'Fatura Numarası',
            invoiceDate: 'Fatura Tarihi',
            cost: 'Tutar',
            actions: 'İşlemler',
            download: 'Fatura İndir',
            downloadExcel: 'Excel İndir',
            notFound: 'Aradığınız kritere uygun fatura bulunamadı',
            noData: 'Fatura bulunamadı',
            fetchError: 'Fatura bilgileri alınırken bir hata oluştu',
            noOptions: 'Fatura tipi bulunamadı',
            selectServiceType: 'Fatura tipi seçiniz',
            clean: 'Temizle',
            invoiceType: 'Fatura Tipi',
            expectedInvoices: {
              invoices: 'Beklenen Faturalar',
              actions: 'İşlemler',

              info: 'MP Fatura Bilgileri',
              requestDate: 'Talep Tarihi',
              desc: 'Açıklama',
              kdv: 'KDV Oranı',
              expectedCost: 'Beklenen Fatura Tutarı',
              invoiceCode: 'Fatura Kodu',
              status: 'Durumu',
              upload: 'Fatura Yükle',
            },
          },
          invoiceRequests: {
            title: 'Fatura Talepleri',
            periodSelect: 'Dönem Seçiniz',
            questionButton: 'Sorgula',
            invoiceStatus: 'Fatura Durumu',
            termDate: 'Dönem Tarihi',
            referenceNumber: 'Referans Numarası',
            totalAmounttoBeDeducted: 'Kesilecek Toplam Tutar',
            amountWithoutVAT: "KDV'siz Tutar",
            vatAmount: "KDV'li Tutar",
            detail: 'Detay',
            invoiceRequestDetailModal: {
              productName: 'Ürün İsmi',
              orderNumber: 'Sipariş Numarası',
              productAmount: 'Ürün Tutar',
              productInvoiceAmount: 'Ürün Fatura Tutarı',
              platformDiscountAmount: 'Platform İndirim Tutarı',
            },
          },
          vendorReconciliations: {
            title: 'Dönem Mutabakatlarım',
            periodSelect: 'Dönem Seçiniz',
            reconciliationID: 'Mutabakat ID',
            reconciliationStatus: 'Mutabakat Durumu',
            price: 'Tutar',
            period: 'Dönem',
            approveDate: 'Onay/Red Tarihi',
            approveStatus: 'Onay/Red Durumu',
            uploadFiles: 'Yüklediğim Dosyalar',
            reconciliationArchive: 'Mutabakat Arşivi',
            filter: 'Filtrele',
            clean: 'Temizle',
          },
          records: {
            records: 'KAYITLAR',
            type: 'Kayıt Tipi',
            sales: 'Satış',
            cancel: 'İptal',
            return: 'İade',
            punishment: 'Ceza',
            processDate: 'İşlem Tarihi',
            vestingDate: 'Hakediş Tarihi',
            filter: 'Filtrele',
            processType: 'İşlem Tipi',
            recordNo: 'Kayıt No',
            shipmentNo: 'Sevkiyat No',
            orderNo: 'Sipariş Kalem No',
            orderNumber: 'Sipariş No',
            orderDate: 'İşlem Tarihi',
            detail: 'Detay',
            cost: 'Tutar',
            commission: 'Komisyon',
            stopaj: 'Stopaj',
            lastCost: 'Net Tutar',
            selectTransactionType: 'İşlem Tipini Seçiniz',
          },
          payment: {
            payment: 'ÖDEMELER',
            date: 'Tarih Aralığı',
            filter: 'Filtrele',
            paymentNo: 'Ödeme No',
            supplier: 'Tedarikçi',
            ibanFromPayment: 'Ödeme Yapılan IBAN',
            account: 'Hesap Sahibi',
            paymentDate: 'Ödeme Tarihi',
            downloadExcel: 'Excel İndir',
            cost: 'Tutar',
            actions: 'İşlemler',
            detail: 'Detay',
            clean: 'Temizle',
          },
          current: {
            date: 'Tarih Aralığı',
            current: 'CARİ HESAP EKSTRESİ',
            create: 'Oluştur',
            no: 'Ekstre No',
            actions: 'İşlemler',
            period: 'Dönem',
            desc: 'Açıklama',
            createdDate: 'Oluşturma Tarihi',
            download: 'Ekstreyi  İndir',
            notFound: 'Aradığınız kritere uygun fatura bulunamadı',
            noData: 'Tarih aralığını girerek ekstrenizi oluşturabilirsiniz',
            fetchError: 'Cari hesap ekstresi alınırken bir hata oluştu',
          },
        },
        orders: {
          orderManagement: {
            selectServiceType: 'Fatura Tipi Seçiniz',
            bulkTransactions: 'Toplu İşlemler',
            shipmentNo: 'Sevkiyat Numarası',
            action: 'Aksiyon',
            cargoSelect: 'Kargo seçiniz...',
            showUploadedInvoice: 'Yüklenen Faturayı Göster',
            deleteUploadedInvoice: 'Yüklenen Faturayı Sil',
            pageTitle: 'SİPARİŞLER',
            allOrders: 'TÜM SİPARİŞLER',
            new: 'YENİ',
            processed: 'İŞLEME ALINDI',
            inCaseOfTransport: 'TAŞIMA DURUMUNDA',
            delivered: 'TESLİM EDİLEN',
            undelivered: 'TESLİM EDİLEMEDİ',
            missingItems: 'EKSİK ÜRÜN',
            reshipped: 'TEKRAR SEVK EDİLEN',
            shipmentInformation: 'Sevkiyat Bilgisi',
            orderNo: 'Sipariş Numarası',
            productCode: 'Barkod ',
            cargo: 'Kargo',
            sellerDiscounts: 'Satıcı İndirimleri',
            customerName: 'Müşteri Adı',
            orderStartDate: 'Sipariş Başlangıç Tarihi',
            orderExpiryDate: 'Sipariş Bitiş Tarihi',
            shippingCode: 'Kargo Kodu',
            showDelayedOrders: 'Geciken Siparişleri Göster',
            invoiceEntryExpected: 'Fatura Girişi Beklenen Siparişleri',
            search: 'Ara',
            clean: 'Temizle',
            orderDate: 'Sipariş Tarihi',
            orderDateNewToOld: 'Sipariş Tarihi (Yeniden Eskiye)',
            orderDateOldToNew: 'Sipariş Tarihi (Eskiden Yeniye)',
            downloadExcel: 'Excel İndir',
            orderInformation: 'Sipariş Bilgisi',
            mainProductState: 'Sigortalanan Ürün Bilgileri',
            customer: 'Müşteri',
            productInformation: 'Ürün Bilgisi',
            piece: 'Adet',
            unitPrice: 'Birim Fiyat',
            cargoInformation: 'Kargo Bilgileri',
            orderStatus: 'Sipariş Durumu',
            invoice: 'Fatura',
            contactAdmin: 'Admin ile iletişime geç',
            allProductInformation: 'Tüm ürün bilgileri',
            enterShippingCode: "Kargo URL'i/Kodu Gir",
            printLabelA4: 'Etiketi A4 Yazdır',
            printLabelSticker: 'Etiketi Sticker Yazdır',
            transactions: 'İşlemler',
            process: 'İşleme Al',
            invoiceNotify: 'Fatura Kesildi Bildirimi Yap',
            changeShippingOption: 'Gönderi Seçeneğini Değiştir',
            createMissingProductPackage: 'Eksik Ürün Paketi Oluştur',
            desiNotify: 'Paket Desi Bildir',
            splitDelivery: 'Teslimatı Böl',
            cancelOrder: 'Siparişi İptal Et',
            createRefund: 'İade Oluştur',
            digitalDeliverySendCode: 'Kod Gönder',
            laborCostAmount: 'İşçilik Bedeli Tanımla',
            invoiceTransactions: 'Fatura İşlemleri',
            uploadInvoice: 'Fatura Yükle',
            deleteInvoice: 'Fatura Sil',
            billingInformation: 'Fatura Bilgileri',
            processApproveAll: 'Toplu İşleme Al',
            additionalShipmentInfo: 'Ek Sevkiyat Bilgileri',
            cargoKey: "Kargo Kodu",
            cargoCompany: "Kargo Firması",
            notFoundTexts: {
              byFilter: 'Filtrenize uygun sipariş bulunamadı.',
              all: 'Sipariş bulunamadı.',
              new: 'Yeni sipariş bulunmamakta.',
              picking: 'İşleme alınan sipariş bulunmamakta.',
              inCargo: 'Taşıma durumunda olan sipariş bulunmamakta.',
              delivered: 'Teslim edilen sipariş bulunmamakta.',
            },
            addImageModal: {
              uploadImageTitle: 'Görsel Yükle',
              uploadImage: 'Görsel Yükle',
              imageType: 'jpeg, png',
              load: 'Yükle',
            },
            invoiceNotifyModal: {
              cargoNumber: 'Fatura Numarası',
              save: 'Kaydet',
              cancel: 'İptal',
              invoiceNotify: 'Fatura Bildirimi',
              requestDetail: 'Talep Detayı',
              addImage: 'Görsel Ekle',
              submitRequest: 'Talebi Gönder',
            },
            digitalDeliveryModal: {
              invoiceNotify: 'Kod Gönder',
              sendCode: 'Kodu Gönder',
              digitalProductCode: 'Dijital Ürün Kodunu Aşağıya Yazın:',
              cancel: 'Kapat',
            },
            adminContactModal: {
              contactAdmin: 'Admin İle İletişime Geç',
              requestDetail: 'Talep Detayı',
              addImage: 'Görsel Ekle',
              submitRequest: 'Talebi Gönder',
            },
            billingInformationModal: {
              billingInformation: 'Fatura Bilgileri',
              deliveryAddress: 'Teslimat Adresi',
              nameSurname: 'Ad Soyad: ',
              taxOffice: 'Vergi Dairesi: ',
              taxNumber: 'VKN: ',
              company: 'Firma Adı: ',
              identificationNumber: 'TC Kimlik No: ',
              address: 'Adres: ',
              billingAddress: 'Fatura Adresi',
              phoneNumber: 'Telefon Numarası: ',
              print: 'Yazdır',
            },
            cancelOrderModal: {
              cancelOrder: 'Siparişi İptal Et',
              noOrderText: 'Sipariş bilgileri içerisinde ürün olmadığı için iptal işlemine izin veremiyoruz. Lütfen admin ile iletişime geçin.',
              ifYouCancelTheOrderText: 'Siparişi iptal etmeniz durumunda sözleşmeniz gereği belirli bir tutarda ceza ile karşılaşacaksınız.',
              image: 'Görsel',
              nameProduct: 'Ürün Adı',
              barcode: 'Barkod',
              size: 'Beden',
              colour: 'Renk',
              piece: 'Adet',
              amount: 'Tutar',
              reasonForCancellation: 'İptal Sebebi',
              choose: 'Seçiniz',
              couldNotSupplied: 'Tedarik edilemedi.',
              totalAmountToBeCanceled: 'İptal edilecek toplam tutar:',
              cancel: 'Sipariş(ler)i İptal Et',
              productInformation: 'Ürün Bilgisi',
            },
            cancellationProcess: {
              pleaseSelectATransaction: 'Siparişi iptal etmek istediğinize emin misiniz?',
              giveUp: 'Hayır',
              approve: 'Evet',
            },
            deleteInvoiceConfirmation: {
              pleaseSelectATransaction: 'Faturayı silmek istediğinize emin misiniz?',
              giveUp: 'Hayır',
              approve: 'Evet',
            },
            undeliveredConfirmation: {
              pleaseSelectATransaction: 'Siparişin durumu teslim edilmedi olarak değiştirilecektir. Devam etmek istediğinize emin misiniz?',
              giveUp: 'Hayır',
              approve: 'Evet',
            },
            diviceDeliveryModal: {
              splitDelivery: 'Teslimatı Böl',
              create2NewShipmentNumbersText: 'Teslimatı böldüğünüzde sistem mevcut sevkiyat numarasını iptal edip 2 yeni sevkiyat numarası oluşturacaktır.',
              warningText: 'Bir tane ürün olduğu için teslimatı bölemezsiniz.',
              image: 'Görsel',
              nameProduct: 'Ürün Adı',
              barcode: 'Barkod',
              productInformation: 'Ürün Bilgisi',
              piece: 'Adet',
              createNewDeliveryPackage: 'Yeni Teslimat Paketi Oluştur',
            },
            shippingOptionModal: {
              shippingOption: 'Gönderi Seçeneği',
              whichOptionWouldText: 'Paketi hangi seçenek ile göndermek istersiniz ?',
              iWantToSendIdefix: 'İdefix anlaşmalı kargo firması ile göndermek istiyorum',
              chooseAShippingCompany: 'Kargo firması seçiniz',
              choose: 'Seçiniz',
              chooseShipping: 'Kargo Seçiniz',
              cargoTrackingCode: 'Kargo takip kodu',
              iWantToSendAlternative: 'Alternatif teslimat ile göndermek istiyorum',
              iWantToSendAlternativeCargoText: 'idefix anlaşması olmayan kargo firması ile göndermek istiyorum',
              cargoTrackingUrlAddress: 'Kargo Takip URL Adresi',
              iWantToSendAlternativeVehicleText: 'Kendi aracımla / yetkili servis ile göndermek istiyorum.',
              deliveryType: 'Teslimat Tipi',
              byMyOwnVehicle: 'Kendi Aracımla',
              authorizedService: 'Yetkili Servis',
              communicationInformation: 'İletişim Bilgisi',
              changeShippingOption: 'Gönderi Seçeneğini Değiştir',
            },
            desiNotifyModal: {
              desiNotify: 'Paket Desi Bildir',
              boxQuantity: 'Kutu Adedi',
              desi: 'Desi',
            },
            uploadInvoiceModal: {
              uploadInvoice: 'Fatura Yükle',
              uploadInvoiceToSystem: 'Faturayı sisteme yükle',
              invoiceTtype: 'jpg, jpeg, png, pdf',
              saveLink: 'Yükle',
              load: 'Yükle',
              loading: 'Yükleniyor...',
              save: 'Sisteme kaydet',
              clear: 'Temizle',
            },
            createDeliveryDocument: {
              uploadInvoice: 'Fatura Yükle',
              uploadInvoiceToSystem: 'Teslim belgesi yükle',
              invoiceTtype: 'jpg, jpeg, png, pdf',
              sendSms: 'Müşteriye Kodu Gönder',
              sendSmsLoading: 'Gönderiliyor...',
              confirmCode: 'Onayla',
              confirmCodeLoading: 'Lütfen bekleyin...',
              load: 'Yükle',
              loading: 'Yükleniyor...',
              save: 'Sisteme kaydet',
              clear: 'Temizle',
              markDelivered: 'Teslim Edildi İşaretle',
            },
            createDeliveryProcess: {
              pleaseSelectATransaction: 'Lütfen Bir İşlem Seçiniz.',
              giveUp: 'Vazgeç',
              approve: 'Onayla',
            },
            createReturnRequestModal: {
              createRefund: 'İade Oluştur',
              image: 'Görsel',
              nameProduct: 'Ürün Adı',
              barcode: 'Barkod',
              size: 'Beden',
              colour: 'Renk',
              piece: 'Adet',
              reasonForReturn: 'İade Nedeni',
              createReturnRequest: 'İade Talebi Oluştur',
              notReachedCustomer: 'Müşteriye Ulaşmamış',
              returnToWarehouse: 'Depoya İade',
              choose: 'Seçiniz',
              comment: 'Açıklama',
              productInformation: 'Ürün Bilgileri',
              returnVendorCargoProfileIsEmptyMessage: 'Varsayılan iade kargo firması tanımlanmamıştır. Lütfen varsayılan iade kargo firması tanımlayınız.',
              createVendorCargoProfile: 'Kargo Firması Tanımla',
              selectClaimMethod: 'İade Yöntemi Seçiniz*',
              selectCargo: 'Kargo Seçiniz*',
              selectCompany: 'Firma Seçiniz*',
              appointmentDate: 'İade Randevu Tarihi*',
              adress: 'Adres',
              warning: 'Uyarı',
            },
            createReturnRequestApproveModal: {
              pleaseSelectATransaction: 'Siparişin durumu teslim edilmedi olarak değiştirilecektir. Devam etmek istediğinize emin misiniz?',
              giveUp: 'Vazgeç',
              approve: 'Onayla',
            },
            createMissingProductModal: {
              createMissingProduct: 'Eksik Ürün Sevkiyat Oluştur',
              createMissingProductShipment: 'Eksik Ürün Paketi Oluştur',
            },
            missingProductModal: {
              createMissingProduct: 'Eksik Ürün Sevkiyat Oluştur',
              selectMissingProducts: 'Eksik olan ürünleri seçin',
              createMissingProductPackage: 'Eksik ürün paketi oluştur',
              nameProduct: 'Ürün Adı',
              piece: 'Adet',
              ok: 'Tamam',
            },
            shippingCodeModal: {
              save: 'Kaydet',
              enterShippingCode: 'Kargo Kodu Gir',
              cargoTrackingUrlAddress: 'Kargo Takip URL Adresi',
              cargoTrackingCode: 'Kargo Takip Kodu',
            },
            laborCostAmountModal: {
              save: 'Kaydet',
              cancel: 'İptal Et',
              defineLaborPrice: 'İşçilik Bedeli Tanımla',
              info: 'İşçilik Bedelini siparişiniz teslim edilmeden önce girmeniz gerekmektedir.',
              infoForDelivery: 'Teslim edilen siparişleriniz için işçilik bedeli tanımlanamamaktadır.',
              infoForStopaj: 'İşçilik bedeli tanımlanmış olan ürün için girilen tutar üzerinden stopaj hesaplanacaktır.',
              productInformation: 'Ürün Bilgileri',
              count: 'Adet',
              unitLaborCost: 'Birim İşçilik Bedeli',
              stockCode: 'Stok Kodu',
              barcode: 'Barkod',
            },
            printLabela4Modal: {
              printLabelA4: 'Etiketi A4 Yazdır',
              billingInformation: 'Fatura Bilgileri', //ToDo
              deliveryAddress: 'Teslimat Adresi',
              nameSurname: 'Ad Soyad: ',
              address: 'Adres: ',
              billingAddress: 'Fatura Adresi',
              phoneNumber: 'Telefon Numarası',
              productAttributes: 'Ürün Özellikleri',
              print: 'Yazdır',
              piece: 'Adet',
              size: 'Beden',
              colour: 'Renk',
              barcode: 'Ürün Barkodu',
              stockCode: 'Stok Kodu',
              productInformation: 'Ürün Bilgileri',
              orderNumber: 'Sipariş No',
              nameProduct: 'Ürün Adı',
            },
            printLabelStickerModal: {
              printLabelSticker: 'Etiketi Sticker Yazdır',
              billingInformation: 'Fatura Bilgileri', //ToDo
              deliveryAddress: 'Teslimat Adresi',
              nameSurname: 'Ad Soyad: ',
              address: 'Adres: ',
              billingAddress: 'Fatura Adresi',
              phoneNumber: 'Telefon Numarası',
              print: 'Yazdır',
            },
          },
          cancellations: {
            allCancellations: 'TÜM İPTALLER',
            customerCanceled: 'MÜŞTERİNİN İPTAL ETTİĞİ',
            iCanceled: 'BENİM İPTAL ETTİĞİM',
            idefixCanceled: "İDEFİX'İN İPTAL ETTİĞİ",
            pageTitle: 'İPTALLER',
            customerName: 'Müşteri',
            shipmentNo: 'Sevkiyat No',
            barcode: 'Barkod',
            shippingCode: 'Kargo Kodu',
            orderNumber: 'Sipariş No',
            cancellationStartDate: 'İptal Başlangıç Tarihi',
            cancellationEndDate: 'İptal Bitiş Tarihi',
            search: 'Ara',
            clean: 'Temizle',
            cancellationDateNewToOld: 'İptal Tarihi (Yeniden Eskiye)',
            cancellationDateOldtoNew: 'İptal Tarihi (Eskiden Yeniye)',
            downloadExcel: 'Excel İndir',
            orderInformation: 'Sipariş Bilgisi',
            customer: 'Müşteri',
            piece: 'Adet',
            productInformation: 'Ürün Bilgileri',
            cancellationAmount: 'İptal Tutarı',
            personCanceled: 'İptal Eden',
            cancellationDate: 'İptal Tarihi',
            reasonForCancellation: 'İptal Sebebi',
            others: 'Diğerleri',
          },
          cargo: {
            cargoInformation: {
              pageTitle: 'Kargo İşlemleri',
              cargoInformations: 'Kargo Bilgisi',
              addNewShippingInformation: 'Yeni Kargo Ekle',
              currentShippingPrices: 'Güncel Kargo Fiyatları',
              downloadPdf: 'Pdf Olarak İndir',
              returnShippingInformation: 'Şubeden İade Kargo Bilgileri',
              homeReturnCargoSelection: 'Evden İade Kargo Seçimi',
              personalDelivery: 'Elden Teslimat',
              orderDeliveryCargoInformation: 'Standart Kargo Seçimi',
              orderFastDeliveryCargoInformation: 'Hızlı Teslimat Kargo Bilgileri',
              orderAppointmentCargoInformation: 'Ertesi Gün Teslimat (Randevulu)',
              addCargoInformationModal: {
                addingShippingInformation: 'Kargo Bilgisi Ekle',
                startingDate: 'Başlangıç Tarihi',
                cargoType: 'Kargo Türü',
                agreementType: 'Anlaşma Tipi',
                selectShipping: 'Kargo Seçiniz',
                defaultCargo: 'Varsayılan Kargo Olarak Ayarla',
                changeActiveShipmentProvider: 'Durumu uygun olan mevcut siparişlere de uygula',
                changeActiveShipmentApplyText: 'Belirlediğiniz kargo profili durumu uygun olan mevcut siparişlere de uygulanacak. Onaylıyor musunuz?',
                active: 'Aktif',
                giveUp: 'Vazgeç',
                save: 'Kaydet',
              },
            },
          },
          refunds: {
            allReturns: 'TÜM İADELER',
            requestMade: 'TALEP OLUŞTURULAN',
            deliveredToCargo: 'KARGOYA VERİLEN',
            waitForAction: 'AKSİYON BEKLEYEN',
            approved: 'ONAYLANAN',
            rejected: 'REDDEDİLEN',
            analysis: 'ANALİZ',
            vendorDeclineRequest: 'RED TALEBİ DEĞERLENDİRME',
            controversial: 'İHTİLAFLI',
            pageTitle: 'İADELER',
            customerName: 'Müşteri',
            orderNumber: 'Sipariş No',
            returnCode: 'İade Kodu',
            barcode: 'Barkod',
            reasonForReturn: 'İade Sebebi',
            choose: 'Seçiniz',
            retrunRequestStartDate: 'İade Başlangıç Tarihi',
            returnRequestEndDate: 'İade Bitiş Tarihi',
            search: 'Ara',
            clean: 'Temizle',
            returnRequestDateNewtoOld: 'İade Talep Tarihi (Yeniden Eskiye)',
            returnRequestDateOldtoNew: 'İade Talep Tarihi (Eskiden Yeniye)',
            downloadExcel: 'Excel İndir',
            returnInformation: 'İade Bilgileri',
            orderInformation: 'Sipariş Bilgisi',
            customer: 'Müşteri',
            piece: 'Adet',
            productInformation: 'Ürün Bilgileri',
            unitPrice: 'Birim Fiyat',
            cargoInformation: 'Kargo',
            invoice: 'Fatura',
            returnStatus: 'İade Durumu',
            others: 'Diğerleri',
            cargoTracking: 'Kargo Takibi',
            approve: 'Onayla',
            refusalRequest: 'Red Talebi',
            sendToService: 'Teknik Servise Göndereceğim',
            iReceivedTheReturn: 'İade Paketi Teslim Alındı',
            writeShippingInformation: 'Kargo Bilgilerini Gir',
            updateShippingInformation: 'Kargo Bilgilerini Güncelle',
            addImageModal: {
              uploadImage: 'Görsel Yükle',
              uploadType: 'jpeg, png',
              load: 'Yükle',
            },
            deniedRequestModal: {
              reasonForRefusal: 'Red Sebebi',
              choose: 'Seçiniz',
              incomingProductUsed: 'Gelen Ürün Kullanılmış',
              otherCustomerNote: 'Diğer(Müşteri Notu)',
              iGiveUp: 'Vazgeçtim',
              purchaseWrongCard: 'Yanlış Kartla Alışveriş Yaptım',
              priceReasoned: 'Fiyat Sebepli',
              iWillNotAddress: 'Adreste Bulunmayacağım',
              deliveryPass: 'Teslim Geçişti',
              description: 'Açıklama (Opsiyonel)',
              addImage: 'Görsel Ekle',
              submitRequest: 'Talebi Gönder',
            },
            declineCargoInfoModal: {
              declineCargoInfoModal: 'Kargo Bilgilerini Gir',
              cargoURL: 'Kargo URL',
              cargoTrackingNumber: 'Kargo Takip Numarası',
              approve: 'Gönder',
            },
            refusalDetailModal: {
              refusalDetail: 'Red Detayları',
              close: 'Kapat',
              customerReturnReason: 'Müşteri Iade Sebebi',
              platformReturnReason: 'Platform Iade Sebebi',
              sellerRejectionReason: 'Satıcı Red Sebebi',
              sellerRejectionNote: 'Satıcı Red Notu',
              platformNote: 'Platform Notu',
              sellerNote: 'Satıcı Notu',
              isDispute: 'Ihtilaflı mı?',
            },
          },
          orderQuestions: {
            pageTitle: 'BİLDİRİMLER',
            dateRange: 'Tarih Aralığı',
            state: 'Durum',
            trademark: 'Marka',
            barcode: 'Barkod',
            myReadyAnswers: 'Hazır Cevaplarım',
            orderNumber: 'Sipariş No',
            customer: 'Müşteri',
            detail: 'Detay',
            process: 'İşlem',
            subject: 'Konu',
            packageNumber: 'Paket No',
            orderDate: 'Sipariş Tarihi',
            questionDate: 'Soru Oluşturma Tarihi',
            allQuestions: 'Tüm Sorular',
            answered: 'Cevaplanan Sorular',
            unanswered: 'Cevap Bekleyen Sorular',
            clean: 'Temizle',
            downloadExcel: 'Excel İndir',
            startDate: 'Başlangıç Tarihi',
            endDate: 'Bitiş Tarihi',
            orderInfo: 'Sipariş Bilgisi',
            situation: 'Durum',
            action: 'Aksiyon',
            customerMessage: 'Müşteri Mesajı',
          },
          evaluation: {
            orderEvaluation: 'SİPARİŞ DEĞERLENDİRMELERİ',
            cargoEvaluation: 'KARGO DEĞERLENDİRMELERİ',
            orderInformation: 'Sipariş Bilgisi',
            evaluationDate: 'Değerlendirme Tarihi',
            evaluationRating: 'Değerlendirme Puanı',
            cargoCompany: 'Kargo Firması',
            sort: 'Sırala',
            hasComment: 'Yalnızca Yorumları Göster',
            evaluationSummary: 'Değerlendirme Özeti',
            orderDate: 'Sipariş Tarihi',
            deliveryDate: 'Teslim Tarihi',
            search: 'Ara',
            clean: 'Temizle',
            ratings: 'Puanlar',
            startDate: 'Başlangıç Tarihi',
            endDate: 'Bitiş Tarihi',
            noCloseReasonMessage: 'Bulunamadı.',
            tooltipMessage: 'Tüm değerlendirmelerin ortalamasını ve dağılımını gösteren alandır.',
            tabs: {
              orderEvaluation: 'Sipariş Değerlendirmeleri',
              cargoEvaluation: 'Kargo Değerlendirmeleri',
            },
          },
        },
        reports: {
          refund: {
            refundReport: 'İade Raporları',
            basedOnProduct: 'Ürün Bazlı Rapor',
            basedOnBrand: 'Marka Bazlı Rapor',
            basedOnCategory: 'Kategori Bazlı Rapor',
            productInfo: 'Ürün Bilgileri',
            salesCount: 'Satış Adedi',
            refundCount: 'İade Adedi',
            refundRate: 'İade Oranı',
            avgSalesPrice: 'Ortalama Satış Fiyatı',
            estLost: 'Tahmini Satış Kaybı',
            order: 'Sıralama',
            filter: 'Filtrele',
            excel: "Excel'e aktar",
          },
          cancel: {
            productInformation: 'Ürün Bilgileri',
            salesCount: 'Satış Adedi',
            cancelCount: 'İptal Adedi',
            cancellationRate: 'İptal Oranı',
            averageSellingPrice: 'Ortalama Satış Fiyatı',
            estimatedLoss: 'Tahmini Satış Kaybı',
          },
          delayed: {},
          sales: {},
        },
        support: {
          pageTitle: 'DESTEK TALEPLERİM',
          userList: 'TALEP LİSTESİ',
          newUser: 'Destek Talebi Oluştur',
          userRole: 'Kullanıcı Rolü',
          userSearch: 'Ara',
          requestType: 'Ticket Tipi',
          ticketId: 'Ticket ID',
          appendices: 'Ek',
          solutionMessage: 'Çözüm Mesajı',
          details: 'Ticket Detayı',
          role: 'Rolü',
          createdDate: 'Oluşturma Tarihi',
          unRead: 'Okunmadı',
          ticketStatus: 'Ticket Durumu',
          state: 'Durum',
          process: 'İşlemler',
          edit: 'Düzenle',
          delete: 'Sil',
          onlyUnread: 'Okunmamış Mesajlar',
          deactive: 'Pasife Al',
          active: 'Aktif Et',
          createSupportRequestModal: {
            title: 'Destek Talebi Oluştur',
            type: 'Destek Talebi Tipi',
            detail: 'Ticket Detayı',
            sellerPaysShippingName: 'Satıcı Öder Kargo Adı',
            cargoAgreementNo: 'Anlaşma Numarası',
            cargoCompanyName: 'Kargo Firması',
            additional: 'Ek',
          },
          messagesModal: {
            title: 'Mesajlar',
            additional: 'Ek',
          },
        },
        agreements: {
          pageTitle: 'Sözleşmeler',
          agreements: 'Sözleşmeler',
          approvalStatus: 'Onay Durumu',
          approvalDate: 'Onay Tarihi',
        },
      },
      layouts: {},
    },
  },
  en: {
    translation: {},
  },
};

export default resources;
